import React, { createContext, useReducer } from "react";
import { CycleFilterReducer } from "../reducers/CycleFilterReducer";

export const CycleFilterContext = createContext();

const CycleFilterContextProvider = (props) => {
  const [cycles, dispatch] = useReducer(CycleFilterReducer, {
    selectedCycles: [],
    allCycles: [],
  });
  return (
    <CycleFilterContext.Provider value={{ cycles, dispatch }}>
      {props.children}
    </CycleFilterContext.Provider>
  );
};

export default CycleFilterContextProvider;



// WEBPACK FOOTER //
// ./src/components/overview/context/CycleFilterContext.js